import type { SessionUser } from '../state/session.js';

export const IS_DEMO: boolean = (() => {
  if (typeof window === 'undefined') return false;
  if (new URLSearchParams(window.location.search).get('demo') === '1') return true;
  if (import.meta.env.VITE_API_URL) return false;
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') return false;
  if (host.endsWith('.local')) return false;
  return true;
})();

export const DEMO_USER: SessionUser = {
  id: 'demo-driver-imran',
  name: 'Imran Baig',
  email: 'imran@raahi.test',
  phone: '+923211110001',
  role: 'driver',
};

export const DEMO_TOKENS = {
  accessToken: 'demo-driver-access',
  refreshToken: 'demo-driver-refresh',
};

export const DEMO_PROFILE = {
  id: 'demo-driver-profile-imran',
  vehicle: { make: 'Suzuki', model: 'Mehran', plate: 'AKL-734', color: 'White', type: 'economy' as const },
  startingPosition: { lat: 24.8642, lng: 67.0099 },
  rating: 4.9,
};
